import { useCallback, memo } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

interface OwnGoogleMapProps {
  lat?: number;
  lng?: number;
}

// Google map megjelenítése
const OwnGoogleMap = ({ lat, lng }: OwnGoogleMapProps) => {
  if (!lat || !lng) return <></>;

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    //@ts-ignore
    googleMapsApiKey: process.env['REACT_GOOGLE_MAP_API_KEY'],
  });

  const location = {
    lat,
    lng,
  };

  const onLoad = useCallback(function callback(myMap: google.maps.Map) {
    myMap.setZoom(17);
  }, []);

  const containerClass = {
    width: '100%',
    height: '100%',
    margin: 'auto',
  };

  return isLoaded ? (
    <>
      <div className='h-[250px] lg:h-[300px] w-full'>
        <GoogleMap mapContainerStyle={containerClass} center={location} onLoad={onLoad}>
          <Marker position={location} />
        </GoogleMap>
      </div>
    </>
  ) : (
    <></>
  );
};

export const MemoizedOwnGoogleMap = memo(OwnGoogleMap);
